import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RatingModel } from 'Modules'
import { Callback } from 'Src/types/utilTypes'

export type RatingState = {}

const initialState: RatingState = {}

export namespace RatingNS {
	export type CreateRating = PayloadAction<{
		rating: RatingModel
		callback?: Callback
		errorCallback?: Callback
	}>
}

export const ratingSlice = createSlice({
	name: 'rating',
	initialState,
	reducers: {
		createRating: (state, action: RatingNS.CreateRating) => {},
	},
})
